var __WEBPACK_NAMESPACE_OBJECT__ = require("hoist-non-react-statics");